import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-type", "data-selected", "data-initial"]
const _hoisted_2 = ["value", "selected", "data-selected"]

import { ref, watch, computed } from "vue";
import { CmsDocument, CmsDocumentTypes } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-select',
  props: {
    type: {},
    initial: {}
  },
  emits: ["on-selection-event"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selected = ref(props.initial || "");
const lastLoadedType = ref<string | null>(null);
const docs = ref<CmsDocument[]>([]);

const dropdownOptions = computed(() => {
  const computedOptions: { value: string; content: string }[] = [];

  computedOptions.push({
    value: "",
    content: "(None)",
  });

  docs.value.forEach((doc: any) => {
    computedOptions.push({
      value: doc.id,
      content: cms.asText(doc.data.name) || cms.asText(doc.data.title) || doc.uid || doc.id,
    });
  });

  if (selected.value && !computedOptions.some((opt) => opt.value === selected.value)) {
    computedOptions.push({
      value: selected.value,
      content: selected.value,
    });
  }

  return computedOptions;
});

const onSelectionEvent = (selectedOption: string): void => {
  emit("on-selection-event", selectedOption);
};

watch(
  () => props.type,
  (newType, oldType) => {
    lastLoadedType.value = newType;
    cms.getAll(newType as CmsDocumentTypes).then((docsRes) => {
      if (lastLoadedType.value === newType) {
        docs.value = docsRes;
      }
    });
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    class: "cms-select",
    "data-type": _ctx.type,
    "data-selected": selected.value,
    "data-initial": _ctx.initial,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (onSelectionEvent(selected.value))),
    "aria-label": "Select an option"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropdownOptions.value, (option) => {
      return (_openBlock(), _createElementBlock("option", {
        key: option.value,
        value: option.value,
        selected: option.value === selected.value,
        "data-selected": option.value === selected.value
      }, _toDisplayString(option.content), 9, _hoisted_2))
    }), 128))
  ], 40, _hoisted_1)), [
    [_vModelSelect, selected.value]
  ])
}
}

})